import Main from "./Main";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getPincodeGlobalCatalogMasterData } from "../actions/PincodeAction";
import {
  setAuthUser,
  getUserDetails,
  signOutUser,
  createUser,
  setStore,
  setHasAccessToMultipleStores,
  setCashRegister,
  getUserACL,
  setCashRegisterClosing,
  updateUser,
  setUAT,
} from "../actions/userAction";

import {
  saveFeedback,
  deleteFeedback,
  getFeedbacks,
  getFeedbackById,
  getFeedbackByTemplateId,
  getFeedbackLinks,
  deleteFeedbackLink,
  saveFeedbackLink,
  getFeedbackResponsesByLinkId,
  saveFeedbackResponse
} from "../actions/FeedbackAction";
import {
  getHelpDeskConfiguration,
  saveHelpDeskConfiguration,
  getHelpDeskType,
  deleteHelpDeskType,
  saveHelpDeskType,
  getHelpDeskTickets,
  sendHelpDeskTicketMessage,
  updateHelpDeskTicket,
  saveTicket
} from "../actions/HelpDeskAction";
import {
  getPosts,
  savePost,
  deactivatePost,
  publishPost,
  getNextSequenceNo,
} from "../actions/PostAction";
import {
  getRegistration,
  updateRegistrationGeneralDetails,
} from "../actions/RegistrationAction";
import {
  uploadFileToServer,
  uploadImagesToServer,
} from "../actions/fileUploadAction";
import {
  getWhatsappAllProviders,
  getWalletBalance,
  getHistoryData,
  updateCredentials,
  updateProvider,
  toggleProvidersActive,
  setupCredentials,
  getTemplates,
  togglePosibleTemplateStatus,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  getEventVariables,
  getWhatsappActiveProvider
} from "../actions/WhatsappAction";
import {
  createOnlinePayment,
  getLogisticProvider,
  saveLogisticProvider,
  getSMSTemplateBySMSType
} from "../actions/IntegrationAction";
import {
  pushProductToRedux,
  getActiveProducts,
  addNewProduct,
  // updateProductImage,
  getProducts,
  deleteProduct,
  getProductsForExport,
  getProductDetails,
  updateProduct,
  // updateProductVariants,
  getProductsForInventorySearch,
  getProductsByBarCode,
  getProductsBySKU,
  // getProductsSearch,
  pushProductsToRedux,
  poupulateSaleCategories,
  poupulateSaleSubCategories,
  getProductsForPOSearch,
  checkIfSKUExists,
  getInstockDetailSingleProduct,
  getInstockProductApi,
  getProductIdInventoryTransaction,
  getProductIdSalesTransaction,
  getProductAuditTrail
} from "../actions/ProductAction";
import {
  searchCustomer,
  addCustomer,
  getCustomers,
  getCustomerDetails,
  updateCustomer,
  deleteCustomer,
  getCustomerDashboardHeaders,
  getWalletLedgersByCustomerID,
  getCustomerTransactions,
  checkIfCustomerPhoneNoIsUnique,
  checkIfCustomerStoreMappingExists,
  pushCustomersToRedux,
  getLoyaltyLedgersByCustomerID,
  getPackagesByCustomerID,
  getTopProductsForACustomer,
  getCustomerDetailsByStoreID,
  getCustomerProductsFromDenomSales,
  getUniqueNosByCustomerIdProductId
} from "../actions/CustomerAction";
import {
  generateOTP,
  validateOTP,
  addSales,
  updateSales,
  updateSalesStatus,
  cancelSales,
  getSaleDetails,
  getKOTRunningNo,
  getCashRegisterOpeningDetails,
  openCashRegister,
  getPaymenDetailstForCashRegisterClosing,
  closeCashRegister,
  getCashRegisterClosingList,
  getCashRegisterClosingDetails,
  getCustomerOutstanding,
  getOutstandingRRN,
  outForDelivery,
  markDelivered,
  readyForPickup,
  getDeliveryDetailReport,
  getDeliveryDetailReportInfinityApp,
  getDeliveryStatusSummary,
  updateDeliveryDetails,
  saveKOT,
  orderConfirmed,
  updateONDCDeliveryStatus,
  generatePowerUserOTP,
  getSalesHistory,
  validatePowerUserOTP,
  generateEInvoice,
} from "../actions/SalesAction";
import {
  addNewStore,
  getUserStores,
  getStoresList,
  deleteStore,
  getStoreDetails,
  updateStore,
  checkIfStoreCodeIsUnique,
  saveBarcodeSetting,
  getBarcodeSettingDetails,
  setStores,
} from "../actions/StoresAction";
import {
  addStoreLocation,
  getStoreLocations,
  deleteStoreLocations,
  updateStoreLocation,
} from "../actions/StoreLocationsAction";
import {
  addCashRegister,
  getCashRegisters,
  deleteCashRegister,
  updateCashRegister,
  updateLastClosingBalance,
  getLastClosingBalance,
} from "../actions/CashRegisterAction";
import {
  addNewEmployee,
  getEmployees,
  deleteEmployee,
  getEmployeeDetails,
  updateEmployee,
  checkIfEmployeeCodeIsUnique,
  getActiveEmployees,
  getEmployeeServices,
  saveEmployeeServices,
} from "../actions/EmployeesAction";
import {
  getCustomFieldNames,
  saveCustomFieldNames,
} from "../actions/CustomFieldsAction";
import {
  getAllCustomFieldNames,
  getSalesChannel,
  getCountries,
  getCurrencyDenominations,
  getAllCountries,
  updateCountryConfig,
  setPageFiltersV1,
  setSelectedMenu,
  setSelectedSubMenu,
  // setSalesChannel,
  setSelectedSalesChannel,
  setNewOnlineOrder,
} from "../actions/ConfigAction";
import {
  getPaymentTypes,
  savePaymentType,
  deletePaymentType,
} from "../actions/PaymentTypes";
import {
  getProductBrands,
  deleteProductBrand,
  saveProductBrand,
} from "../actions/ProductBrandsAction";
import {
  getProductTaxes,
  saveProductTaxes,
  deleteProductTax,
} from "../actions/ProductTaxesAction";

import {
  addNewProductCategory,
  updateProductCategory,
  deleteProductCategory,
  addNewProductSubCategory,
  updateProductSubCategory,
  deleteProductSubCategory,
  getProductCategories,
  getProductSubCategories,
  checkIfProductCategoryIsUnique,
  checkIfProductSubCategoryIsUnique,
  getAllProductCategoriesToRedux,
  getAllProductSubCategoriesToRedux,
} from "../actions/ProductCategoryAction";
import {
  getTransactionTypes,
  deleteTransactionType,
  saveTransactionType,
} from "../actions/TransctionTypeAction";
import {
  savePrintConfig,
  deletePrintConfig,
  getPrintConfigs,
  getPrintConfigsList,
  pushPrintConfigToRedux,
} from "../actions/PrintConfigAction";
import {
  getMembership,
  saveMembership,
  deleteMembership,
  getActiveMemberships,
} from "../actions/MembershipAction";
import {
  saveExpenseCategories,
  deleteExpenseCategories,
  getExpenseCategories,
  checkIfExpenseCategoriesIsUnique,
} from "../actions/ExpenseCategoryAction";
import {
  getEmployeeDashboard,
  getEmployeeProductTypeWise,
  getEmployeeTransactionTypeProductTypeWise,
  getBillWiseDetailReport,
  getInvoiceDetailReport,
  getEmployeeItemDetailReport,
  getProductTypeSoldReportData,
  getItemBrandSoldReportData,
  getItemCategorySoldReportData,
  getSubCategoryItemSoldReportData,
  getDashboardHeaders,
  getSalesDashboardPincode,
  getProductWiseSales,
  getProductTransactionTypeWiseSales,
  getCategoryWiseSales,
  getCategoryTransactionTypeWiseSales,
  getEmployeeWiseSales,
  getItemSoldReportData,
  getSalesTransaction,
  getPaymentTypeWiseSales,
  getSalesDashboard,
  getPurchaseDashboard,
  getPurchaseForLast12Months,
  getCustomerReferenceReport,
  getProductTypeWiseSales,
  getPaymentWiseTransaction,
  getWalletWiseTransaction,
  getExpensesforSalesDashboard,
  getExpenseList,
  getExpenseCategoryList,
  getExpenseByParty,
  getItemInStockData,
  getDailySales,
  getDailySalesWithoutReceivePayment,
  getPaymentModeWiseDaily,
  getPaymentModeWiseData,
  getEmployeeWorksheet,
  getPaymentModeTransactionTypeWiseSales,
  getCustomerWalletLedger,
  getCustomerOutStandingLedger,
  getOutStandingLedgerByCustomerID,
  getWalletLedgersByCustomer,
  getUniqueNos,
  getUniqueNoLedger,
  getBulkInstock,
  getItemInStockTotals,
  getVendorLedgerFromInventory,
  getVendorLedgerFromExpense,
  getVendorOpeningBalanceFromExpense,
  getVendorOpeningBalanceFromInventory,
  getCustomersForMembershipValidity,
  getTopSpentCustomers,
  getTopSpentCustomersByCustomerIDs,
  getCustomersForLoyalty,
  getLoyaltyLedger,
  getInventoryHistoryProducts,
  getOpeningStockFromInventoryHistory,
  getOpeningStockFromDenomInventory,
  getStockUpdateFromInventoryHistory,
  getOpeningStockFromDenomSales,
  getProductSoldForAMonth,
  getAvgProductSoldForAPeriod,
  getInventoryHistoryReport,
  getDenomInventoryHistoryReport,
  getInstockQtybyProductIDs,
  getDenomSalesHistoryReport,
  getSalesForLast12Months,
  getBrandWiseSales,
  getBrandTransactionTypeWiseSales,
  getTopGoodsForSales,
  getTopServices,
  getTopWallets,
  getTopPackages,
  getWalkinCustomers,
  getSalesCustomers,
  getRepeatedCustomers,
  getNewCustomers,
  getTopProductType,
  getSpecificPaymentModeSales,
  getTotalPaymentReceived,
  getProfitandLossReport,
  getInvoicesForGSTR1B2B,
  getInvoicesForGSTR1,
  getInvoicesForGSTR1B2C,
  getProductsByProductIDs,
  getSalesBasedOnTransactionTypes,
  getOfferReport,
  getOfferSummaryReport,
  getAttendanceReport,
  getBatchData,
  getActiveProductsForInventoryHistory,
  getHSNWiseSummaryReport,
  getProductSoldBasedOnCashRegister,
  getSalesPaymentModesBySalesIDs,
  getReportConfigs,
  getReportData,
  sendReportExportRequest,
  getDownloadReports,
  getInventorySummary,
  getInventoryValuationSummary,
  getMostPurchaseCategory,
  getMostPurchaseSubCategory,
  getMostPurchaseBrand,
  getQuaterlyPurchase,
  getTopExpenseCategories,
  getMostPurchasedProducts,
  getLowStockData,
  getOutOfStockData,
  getTopVendorPurchases,
  getMembershipDashboard,
  getStoreWisePurchase,
  getLast12MonthPurchase,
  getSubCategoryWiseSales,
  getInventoryPurchaseSalesInstock,
  getAllInvetoryDetailReport
} from "../actions/ReportAction";
import {
  saveExpenses,
  getExpenses,
  searchParty,
  cancelExpense,
  getCashFromCounterAmountForCashRegisterClosing,
  getVendorPendingPayments,
} from "../actions/ExpenseAction";
import {
  searchVendor,
  addNewVendor,
  getVendors,
  deleteVendor,
  getVendorDetails,
  updateVendor,
} from "../actions/VendorAction";
import {
  convertNumberToWords,
  getPrintTemplate,
  sendSMS,
  sendEmail,
  getToastr,
  importCSV,
  getImportLogs,
  getImportDetails,
  getImportLogList,
  getVisibility,
  addDays,
  saveDataForBarcodePrint,
  isMobileApp,
  onStoreChangeResetConfig,
  setSmartStores,
  onStoreChangeResetUser,
  onInventoryLineItemChange,
  connectBlueToothPrinter,
  printTextBlueToothPrinter,
  getStateCodeMaster,
  getVehicleType,
  getModeOfTransport,
  setPageFilters,
  getPageFilters,
  saveDashboardSettings,
  getDashBoardSettings,
  getFoodDeliveryPlatforms,
  getYears,
  getMonths,
  getStartDateOfMonth,
  getEndDateOfMonth,
  getModules,
  saveConnectionStatus,
  isElectron,
  getPetTypes,
  getPetBreeds,
  showModule,
  inventoryPreConditions,
  uploadFile
} from "../actions/CommonAction";
import { getAuditTrails } from "../actions/AuditTrailAction";
import { withRouter } from "react-router";
import { getAttendance, saveAttendance } from "../actions/AttendanceAction";
import {
  addInventory,
  updateInventory,
  cancelInventory,
  getInventoryDetails,
  getInventoryList,
  getProductInStockQty,
  getInwardUniqueList,
  getUniqueNoIDBasedOnTransaction,
  checkIfUniqueNoIsUnique,
  getUniqueListForSalesReturn,
  getInStockQtyForProducts,
  getInTransitInventoryForAStore,
  getInventoryToSale,
  getBatches,
  getBatchAuditTrail,
  getPurchaseEntryForPurchaseReturn,
  deleteInventoryInStock,
  updateInStockQty
} from "../actions/InventoryAction";
import {
  saveProductTag,
  getProductTags,
  deleteProductTag,
} from "../actions/ProductTagAction";
import {
  getOffers,
  saveOffer,
  deleteOffer,
  getOfferDetails,
  getApplicableOffers,
  saveCouponCode,
  getCouponDetails,
  validateCoupon,
} from "../actions/OfferAction";
import {
  getSurveys,
  saveSurvey,
  deleteSurvey,
  getSurveyDetails,
} from "../actions/SurveyAction";

import {
  getModifiers,
  saveModifiers,
  deleteModifiers,
  deleteModifierGroup,
  saveModifierGroup,
  getModifierGroups,
  getActiveModifiers,
} from "../actions/ModifierAction";
import {
  getPackages,
  getPackageDetails,
  updatePackage,
  getCustomerPackages,
} from "../actions/PackageAction";
import {
  getAccounts,
  deleteAccount,
  saveAccount,
  checkIfAccountIsUnique,
} from "../actions/AccountAction";
import {
  getTransactions,
  cancelTransaction,
  saveTransaction,
  getCashDebitEntriesFromAccountManagement,
  getCashCreditEntriesFromAccountManagement,
} from "../actions/TransactionAction";
import {
  saveBOM,
  getBOMList,
  deleteBOMs,
  getBOMDetails,
} from "../actions/BOMAction";
import {
  getCoupons,
  saveCoupon,
  deleteCoupon,
  getApplicableCoupons,
} from "../actions/CouponAction";
import {
  getLoyaltyType,
  deleteLoyaltyType,
  saveLoyaltyType,
  getLoyaltyTypeDetails,
  saveLoyaltySetup,
  getLoyaltySetupDetails,
  getTotalLoyaltyCustomer,
  getCustomerLoyaltyPoints,
  getLoyaltyTypeCustomerCount,
  getLoyaltyPointEarnAndBurn,
  getMonthWiseLoyaltyPointEarnAndBurn,
} from "../actions/LoyaltyAction";

import {
  getCustomerReferralProgram,
  saveCustomerReferralProgram,
  saveReferrals,
  apiGetCustomerReferralProgram,
} from "../actions/CustomerReferralAction";
import {
  saveAppointment,
  getAppointments,
  updateAppointmentStatus,
  cancelAppointment,
  getAppointmentsForAPeriod,
  getAllAppointments,
  getUpcomingAppointmentsForCustomer,
  getPastAppointmentsForCustomer,
  getAppointmentsForCustomer,
} from "../actions/AppointmentAction";
import {
  getSMSTemplates,
  saveSMSTemplate,
  deleteSMSTemplate,
  getSMSTemplateDetails,
  getSMSTemplatesByModule,
} from "../actions/SMS";
import {
  getCampaign,
  deleteCampaign,
  getCampaignDetails,
  getCustmerForCampaign,
  getNonVisitedCustmerForCampaign,
  getSalesCustomersForCampaign,
  addCampaign,
  updateCampaign,
  updateCampaignStatus
} from "../actions/CampaignAction";
import {
  saveDraftTransaction,
  getDraftTransactions,
  deleteDraftTransaction,
} from "../actions/DraftTransaction";
import {
  initiateThirdPartyPayment,
  checkThirdPartyPaymentStatus,
} from "../actions/ThirdPartyPayment";
import {
  saveBusinessCard,
  getBusinessCard,
} from "../actions/BusinessCardAction";

import {
  addProductsFoodDeliveryPlatforms,
  updateProductsFoodDeliveryPlatforms,
  addToFoodDeliveryPlatformUpdateQueue,
  getFoodDeliveryPlatformProducts,
  getFoodDeliveryNewOrders,
  createSalesTransactionForUrbanPiperOrder,
  cancelUrbanPiperOrder,
  getInProgressOrders,
  getCompletedCancelledOrders,
  getLatestOrderNo,
} from "../actions/FoodDeliveryPlatformAction";

import {
  getCustomRoles,
  deleteCustomRoles,
  saveCustomRoles,
  getCustomRoleDetails,
  getModulesForARole,
} from "../actions/CustomRoleAction";

import { updateKOTStatus, getKOTS } from "../actions/KDSAction";

import {
  deleteTable,
  getOpenTableOrders,
  saveTable,
  getTables,
} from "../actions/TableAction";


import { getCancellationReasonCodes } from "../actions/ONDC";

import {
  shadowfaxPlaceOrder,
  shadowfaxCancelOrder,
  shadowfaxUpdateOrder,
} from "../actions/ShadowFaxAction";
import { getMachineDashboardCount, getUniqueNoInstock, getMachineLedger, getMachineServicesById } from "../actions/UniqueNoAction";
import { deleteSalesChannel, saveSalesChannel } from "../services/api/SalesChannelAPI";

function mapStateToProps(state) {
  return {
    user: state.user,
    post: state.post,
    registration: state.registration,
    fileUpload: state.fileUpload,
    product: state.product,
    sales: state.sales,
    config: state.config,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getPincodeGlobalCatalogMasterData,
      uploadFileToServer,
      uploadImagesToServer,
      convertNumberToWords,
      getPrintTemplate,
      sendSMS,
      sendEmail,
      getToastr,
      importCSV,
      getImportLogs,
      getImportDetails,
      getAuditTrails,
      getImportLogList,
      getVisibility,
      addDays,
      saveDataForBarcodePrint,
      isMobileApp,
      onStoreChangeResetConfig,
      setSmartStores,
      onStoreChangeResetUser,
      onInventoryLineItemChange,
      connectBlueToothPrinter,
      printTextBlueToothPrinter,
      getStateCodeMaster,
      getVehicleType,
      getModeOfTransport,
      setPageFilters,
      getPageFilters,
      saveDashboardSettings,
      getDashBoardSettings,
      getFoodDeliveryPlatforms,
      getYears,
      getMonths,
      getStartDateOfMonth,
      getEndDateOfMonth,
      getModules,
      saveConnectionStatus,
      isElectron,
      getPetTypes,
      getPetBreeds,
      showModule,
      inventoryPreConditions,
      uploadFile,
      getRegistration,
      updateRegistrationGeneralDetails,
      setAuthUser,
      setUAT,
      getUserDetails,
      signOutUser,
      createUser,
      setStore,
      setHasAccessToMultipleStores,
      setCashRegister,
      getUserACL,
      setCashRegisterClosing,
      updateUser,
      getPosts,
      savePost,
      deactivatePost,
      publishPost,
      getNextSequenceNo,
      pushProductToRedux,
      getActiveProducts,
      addNewProduct,
      getProducts,
      getProductsForExport,
      deleteProduct,
      getSalesHistory,
      getProductDetails,
      updateProduct,
      getProductsForInventorySearch,
      getProductsByBarCode,
      getProductsBySKU,
      pushProductsToRedux,
      poupulateSaleCategories,
      poupulateSaleSubCategories,
      getProductsForPOSearch,
      checkIfSKUExists,
      searchCustomer,
      addCustomer,
      getCustomers,
      getCustomerDetails,
      updateCustomer,
      deleteCustomer,
      getCustomerDashboardHeaders,
      getWalletLedgersByCustomerID,
      getCustomerTransactions,
      checkIfCustomerPhoneNoIsUnique,
      checkIfCustomerStoreMappingExists,
      pushCustomersToRedux,
      getLoyaltyLedgersByCustomerID,
      getPackagesByCustomerID,
      getTopProductsForACustomer,
      getCustomerDetailsByStoreID,
      generateOTP,
      validateOTP,
      addSales,
      updateSales,
      updateSalesStatus,
      cancelSales,
      getSaleDetails,
      getKOTRunningNo,
      getCashRegisterOpeningDetails,
      openCashRegister,
      getPaymenDetailstForCashRegisterClosing,
      closeCashRegister,
      getCashRegisterClosingList,
      getCashRegisterClosingDetails,
      getCustomerOutstanding,
      getOutstandingRRN,
      outForDelivery,
      markDelivered,
      readyForPickup,
      getDeliveryDetailReport,
      getDeliveryDetailReportInfinityApp,
      getDeliveryStatusSummary,
      updateDeliveryDetails,
      saveKOT,
      orderConfirmed,
      updateONDCDeliveryStatus,
      generatePowerUserOTP,
      validatePowerUserOTP,
      generateEInvoice,
      addNewStore,
      getUserStores,
      getStoresList,
      deleteStore,
      getStoreDetails,
      updateStore,
      checkIfStoreCodeIsUnique,
      saveBarcodeSetting,
      getBarcodeSettingDetails,
      setStores,
      getCountries,
      getCurrencyDenominations,
      getAllCountries,
      updateCountryConfig,
      setPageFiltersV1,
      setSelectedMenu,
      setSelectedSubMenu,
      // setSalesChannel,
      setSelectedSalesChannel,
      setNewOnlineOrder,
      addStoreLocation,
      getStoreLocations,
      deleteStoreLocations,
      updateStoreLocation,
      addCashRegister,
      getCashRegisters,
      deleteCashRegister,
      updateCashRegister,
      updateLastClosingBalance,
      getLastClosingBalance,
      addNewEmployee,
      getEmployees,
      deleteEmployee,
      getEmployeeDetails,
      updateEmployee,
      checkIfEmployeeCodeIsUnique,
      getActiveEmployees,
      getEmployeeServices,
      saveEmployeeServices,
      getCustomFieldNames,
      saveCustomFieldNames,
      getAllCustomFieldNames,
      getSalesChannel,
      getPaymentTypes,
      savePaymentType,
      deletePaymentType,
      getProductBrands,
      deleteProductBrand,
      saveProductBrand,
      getProductTaxes,
      saveProductTaxes,
      deleteProductTax,
      addNewProductCategory,
      updateProductCategory,
      deleteProductCategory,
      addNewProductSubCategory,
      updateProductSubCategory,
      deleteProductSubCategory,
      getProductCategories,
      getProductSubCategories,
      checkIfProductCategoryIsUnique,
      checkIfProductSubCategoryIsUnique,
      getAllProductCategoriesToRedux,
      getAllProductSubCategoriesToRedux,
      getTransactionTypes,
      deleteTransactionType,
      saveTransactionType,
      savePrintConfig,
      deletePrintConfig,
      getPrintConfigs,
      getPrintConfigsList,
      pushPrintConfigToRedux,
      getMembership,
      saveMembership,
      deleteMembership,
      getActiveMemberships,
      saveExpenseCategories,
      deleteExpenseCategories,
      getExpenseCategories,
      checkIfExpenseCategoriesIsUnique,
      getSubCategoryWiseSales,
      // ,getEmployeeDashboard, getEmployeeProductTypeWise,getBillWiseDetailReport,getInvoiceDetailReport,getProductTypeSoldReportData,getItemBrandSoldReportData,getItemCategorySoldReportData,getSubCategoryItemSoldReportData,getEmployeeItemDetailReport,getDashboardHeaders,getProductWiseSales,getCategoryWiseSales,getEmployeeWiseSales,getItemSoldReportData,getSalesTransaction,getPaymentTypeWiseSales,getSalesDashboard,getCustomerReferenceReport,getProductTypeWiseSales,getPaymentWiseTransaction,getWalletWiseTransaction,getExpensesforSalesDashboard, getExpenseList,getExpenseCategoryList,getExpenseByParty, getItemInStockData,getItemLedger, getDailySales,getPaymentModeWiseDaily,getPaymentModeWiseData, getEmployeeWorksheet, getPaymentModeTransactionTypeWiseSales, getAllInvetoryDetailReport,getItemInStockTotals,getVendorLedgerFromInventory , getVendorLedgerFromExpense,getVendorOpeningBalanceFromExpense,getVendorOpeningBalanceFromInventory, getCustomersForMembershipValidity,getTopSpentCustomers,getTopSpentCustomersByCustomerIDs,getCustomersForLoyalty,getLoyaltyLedger,getInventoryHistoryProducts,getOpeningStockFromInventoryHistory,getOpeningStockFromDenomInventory,getStockUpdateFromInventoryHistory,getOpeningStockFromDenomSales,getProductSoldForAMonth, getAvgProductSoldForAPeriod,getInventoryHistoryReport,getDenomInventoryHistoryReport,getDenomSalesHistoryReport
      // ,getMembershipData,getExpiredMembershipData,getActiveMembershipData,getMembershipSales, getPaymentReceivedDaily,getSalesForLast12Months ,getSubCategoryWiseSales, getBrandWiseSales, getTopGoodsForSales, getTopServices, getTopWallets, getTopPackages, getWalkinCustomers, getSalesCustomers, getRepeatedCustomers, getNewCustomers
      getEmployeeDashboard,
      getEmployeeProductTypeWise,
      getEmployeeTransactionTypeProductTypeWise,
      getBillWiseDetailReport,
      getInvoiceDetailReport,
      getEmployeeItemDetailReport,
      getProductTypeSoldReportData,
      getItemBrandSoldReportData,
      getItemCategorySoldReportData,
      getSubCategoryItemSoldReportData,
      getDashboardHeaders,
      getSalesDashboardPincode,
      getProductWiseSales,
      getProductTransactionTypeWiseSales,
      getCategoryWiseSales,
      getCategoryTransactionTypeWiseSales,
      getEmployeeWiseSales,
      getItemSoldReportData,
      getSalesTransaction,
      getPaymentTypeWiseSales,
      getSalesDashboard,
      getPurchaseDashboard,
      getPurchaseForLast12Months,
      getCustomerReferenceReport,
      getProductTypeWiseSales,
      getPaymentWiseTransaction,
      getWalletWiseTransaction,
      getExpensesforSalesDashboard,
      getExpenseList,
      getExpenseCategoryList,
      getExpenseByParty,
      getItemInStockData,
      getDailySales,
      getDailySalesWithoutReceivePayment,
      getPaymentModeWiseDaily,
      getPaymentModeWiseData,
      getEmployeeWorksheet,
      getPaymentModeTransactionTypeWiseSales,
      getCustomerWalletLedger,
      getCustomerOutStandingLedger,
      getOutStandingLedgerByCustomerID,
      getWalletLedgersByCustomer,
      getUniqueNos,
      getUniqueNoLedger,
      getBulkInstock,
      getItemInStockTotals,
      getVendorLedgerFromInventory,
      getVendorLedgerFromExpense,
      getVendorOpeningBalanceFromExpense,
      getVendorOpeningBalanceFromInventory,
      getCustomersForMembershipValidity,
      getTopSpentCustomers,
      getTopSpentCustomersByCustomerIDs,
      getCustomersForLoyalty,
      getLoyaltyLedger,
      getInventoryHistoryProducts,
      getOpeningStockFromInventoryHistory,
      getOpeningStockFromDenomInventory,
      getStockUpdateFromInventoryHistory,
      getOpeningStockFromDenomSales,
      getProductSoldForAMonth,
      getAvgProductSoldForAPeriod,
      getInventoryHistoryReport,
      getDenomInventoryHistoryReport,
      getInstockQtybyProductIDs,
      getDenomSalesHistoryReport,
      getSalesForLast12Months,
      getBrandWiseSales,
      getBrandTransactionTypeWiseSales,
      getTopGoodsForSales,
      getTopServices,
      getTopWallets,
      getTopPackages,
      getWalkinCustomers,
      getSalesCustomers,
      getRepeatedCustomers,
      getNewCustomers,
      getTopProductType,
      getSpecificPaymentModeSales,
      getTotalPaymentReceived,
      getProfitandLossReport,
      getInvoicesForGSTR1B2B,
      getInvoicesForGSTR1,
      getInvoicesForGSTR1B2C,
      getProductsByProductIDs,
      getSalesBasedOnTransactionTypes,
      getOfferReport,
      getOfferSummaryReport,
      getAttendanceReport,
      getBatchData,
      getActiveProductsForInventoryHistory,
      getHSNWiseSummaryReport,
      getProductSoldBasedOnCashRegister,
      getSalesPaymentModesBySalesIDs,
      getReportConfigs,
      getReportData,
      sendReportExportRequest,
      getDownloadReports,
      getInventorySummary,
      getInventoryValuationSummary,
      getMostPurchaseCategory,
      getMostPurchaseSubCategory,
      getMostPurchaseBrand,
      getQuaterlyPurchase,
      getTopExpenseCategories,
      getLowStockData,
      getOutOfStockData,
      getMostPurchasedProducts,
      getTopVendorPurchases,
      getMembershipDashboard,
      getStoreWisePurchase,
      getLast12MonthPurchase,
      getCustomerWalletLedger,
      getCustomerOutStandingLedger,
      getOutStandingLedgerByCustomerID,
      getWalletLedgersByCustomer,
      getUniqueNos,
      getUniqueNoLedger,
      getBulkInstock,
      getExpenses,
      searchParty,
      cancelExpense,
      saveExpenses,
      getCashFromCounterAmountForCashRegisterClosing,
      getVendorPendingPayments,
      searchVendor,
      addNewVendor,
      getVendors,
      deleteVendor,
      getVendorDetails,
      updateVendor,
      getAttendance,
      saveAttendance,
      addInventory,
      updateInventory,
      cancelInventory,
      getInventoryDetails,
      getInventoryList,
      getProductInStockQty,
      getInwardUniqueList,
      getUniqueNoIDBasedOnTransaction,
      checkIfUniqueNoIsUnique,
      getUniqueListForSalesReturn,
      getInStockQtyForProducts,
      getInTransitInventoryForAStore,
      getInventoryToSale,
      getBatches,
      getBatchAuditTrail,
      getPurchaseEntryForPurchaseReturn,
      deleteInventoryInStock,
      updateInStockQty,
      saveProductTag,
      getProductTags,
      deleteProductTag,
      getOffers,
      saveOffer,
      deleteOffer,
      getOfferDetails,
      getApplicableOffers,
      saveCouponCode,
      getCouponDetails,
      validateCoupon,
      getSurveys,
      saveSurvey,
      deleteSurvey,
      getSurveyDetails,
      getModifiers,
      saveModifiers,
      deleteModifiers,
      deleteModifierGroup,
      saveModifierGroup,
      getModifierGroups,
      getActiveModifiers,
      getPackages,
      getPackageDetails,
      updatePackage,
      getCustomerPackages,
      getAccounts,
      deleteAccount,
      saveAccount,
      checkIfAccountIsUnique,
      getTransactions,
      cancelTransaction,
      saveTransaction,
      getCashDebitEntriesFromAccountManagement,
      getCashCreditEntriesFromAccountManagement,
      saveBOM,
      getBOMList,
      deleteBOMs,
      getBOMDetails,
      getCoupons,
      saveCoupon,
      deleteCoupon,
      getApplicableCoupons,
      getLoyaltyType,
      deleteLoyaltyType,
      saveLoyaltyType,
      getLoyaltyTypeDetails,
      saveLoyaltySetup,
      getLoyaltySetupDetails,
      getTotalLoyaltyCustomer,
      getCustomerLoyaltyPoints,
      getLoyaltyTypeCustomerCount,
      getLoyaltyPointEarnAndBurn,
      getMonthWiseLoyaltyPointEarnAndBurn,
      getCustomerReferralProgram,
      saveCustomerReferralProgram,
      saveReferrals,
      apiGetCustomerReferralProgram,
      saveAppointment,
      getAppointments,
      updateAppointmentStatus,
      cancelAppointment,
      getAppointmentsForAPeriod,
      getAllAppointments,
      getUpcomingAppointmentsForCustomer,
      getPastAppointmentsForCustomer,
      getAppointmentsForCustomer,
      getSMSTemplates,
      saveSMSTemplate,
      deleteSMSTemplate,
      getSMSTemplateDetails,
      getSMSTemplatesByModule,
      getCampaign,
      deleteCampaign,
      getCampaignDetails,
      getCustmerForCampaign,
      getNonVisitedCustmerForCampaign,
      getSalesCustomersForCampaign,
      addCampaign,
      updateCampaign,
      updateCampaignStatus,
      saveDraftTransaction,
      getDraftTransactions,
      deleteDraftTransaction,
      initiateThirdPartyPayment,
      checkThirdPartyPaymentStatus,
      addProductsFoodDeliveryPlatforms,
      updateProductsFoodDeliveryPlatforms,
      addToFoodDeliveryPlatformUpdateQueue,
      getFoodDeliveryPlatformProducts,
      getFoodDeliveryNewOrders,
      createSalesTransactionForUrbanPiperOrder,
      cancelUrbanPiperOrder,
      getInProgressOrders,
      getCompletedCancelledOrders,
      getLatestOrderNo,
      saveBusinessCard,
      getBusinessCard,
      // ,getOmniInquiries
      getCustomRoles,
      deleteCustomRoles,
      saveCustomRoles,
      getCustomRoleDetails,
      getModulesForARole,
      updateKOTStatus,
      getKOTS,
      deleteTable,
      getOpenTableOrders,
      saveTable,
      getTables,
      getCancellationReasonCodes,
      shadowfaxPlaceOrder,
      shadowfaxCancelOrder,
      shadowfaxUpdateOrder,
      getWhatsappAllProviders,
      getWalletBalance,
      getHistoryData,
      updateCredentials,
      updateProvider,
      toggleProvidersActive,
      setupCredentials,
      getTemplates,
      togglePosibleTemplateStatus,
      createTemplate,
      updateTemplate,
      deleteTemplate,
      getEventVariables,
      createOnlinePayment,
      getLogisticProvider,
      saveLogisticProvider,
      getSMSTemplateBySMSType,
      getInstockDetailSingleProduct,
      getInstockProductApi,
      getProductIdInventoryTransaction,
      getProductIdSalesTransaction,
      getProductAuditTrail,
      getHelpDeskConfiguration,
      saveHelpDeskConfiguration,
      getHelpDeskType,
      deleteHelpDeskType,
      saveHelpDeskType,
      sendHelpDeskTicketMessage,
      getHelpDeskTickets,
      updateHelpDeskTicket,
      getInventoryPurchaseSalesInstock,
      getMachineLedger,
      getMachineServicesById,
      getAllInvetoryDetailReport,
      saveTicket,
      getCustomerProductsFromDenomSales,
      getMachineDashboardCount,
      getUniqueNoInstock,
      getWhatsappActiveProvider,
      deleteSalesChannel,
      saveSalesChannel,
      saveFeedback,
      deleteFeedback,
      getFeedbackById,
      getFeedbacks,
      getFeedbackLinks,
      getFeedbackByTemplateId,
      deleteFeedbackLink,
      saveFeedbackLink,
      getFeedbackResponsesByLinkId,
      saveFeedbackResponse,
      getUniqueNosByCustomerIdProductId
    },
    dispatch
  );
}

const App = withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));

export default App;
